// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  border: 1px solid;
  padding: 30px 30px;
  border-radius: 10px;
}

.fromtop {
  margin-top: 3px;
}

.mat-column-select {
  overflow: initial;
}

table {
  width: 95%;
}

tr {
  height: 6rem;
}

.mat-mdc-row .mat-mdc-cell {
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  cursor: pointer;
}

.mat-mdc-row:hover .mat-mdc-cell {
  border-color: currentColor;
}

.demo-row-is-clicked {
  font-weight: bold;
}

.row-end {
  margin-top: 1.2rem;
  margin-bottom: 1.2rem;
  margin-right: 0.8rem;
  display: flex;
  flex-direction: row-reverse;
}

.pay-inv:not([disabled]) {
  background-color: rgb(238, 70, 81);
  color: white;
}

.save-button-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-left: 24px;
  gap: 8px;
}

.save-btn {
  background-color: rgb(238, 70, 81);
  color: white;
  width: 52px;
  height: 52px;
  border-radius: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}
.save-btn:not([disabled]):hover {
  background-color: #ea1725;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
}
.save-btn[disabled] {
  background-color: #e0e0e0;
  color: #9e9e9e;
  box-shadow: none;
  transform: none;
}
.save-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.pdf-btn {
  background-color: #d32f2f;
}
.pdf-btn:not([disabled]):hover {
  background-color: #ab2424;
}

table tr {
  height: auto;
}

table th {
  background-color: rgb(238, 70, 81);
  color: white;
  height: 50px;
}

table, th:first-child {
  border-top-left-radius: 10px;
}

table, th:last-child {
  border-top-right-radius: 10px;
}

table {
  background-color: var(--primary-grey-light);
}

.mat-elevation-z2 {
  border-radius: 10px;
  max-height: 60vh;
  overflow-y: clip;
}

.paginator {
  background-color: var(--primary-grey-light);
  border-bottom-left-radius: var(--def-padding);
  border-bottom-right-radius: var(--def-padding);
}

::ng-deep .hide-arrow .mat-sort-header-arrow {
  color: #fff;
}

.paginator {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}

.total-summary-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.total-info, .invoice-count {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: right;
  margin-bottom: 8px;
}

.total-label, .count-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  margin-right: 8px;
}

.total-amount, .count-number {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/invoicev2/invoice.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AACA;EACC,iBAAA;EACA,kBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,eAAA;AAAD;;AAGA;EACC,iBAAA;AAAD;;AAGA;EACC,UAAA;AAAD;;AAGA;EACC,YAAA;AAAD;;AAGA;EACC,oCAAA;EACA,iCAAA;EACA,eAAA;AAAD;;AAGA;EACC,0BAAA;AAAD;;AAGA;EACC,iBAAA;AAAD;;AAGA;EACC,kBAAA;EACG,qBAAA;EACA,oBAAA;EACH,aAAA;EACA,2BAAA;AAAD;;AAGA;EACI,kCCxCY;EDyCX,YC3CY;AD2CjB;;AAIA;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;AADJ;;AAIA;EACI,kCCtDY;EDuDZ,YCzDa;ED0Db,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;AADJ;AAGI;EACI,yBAAA;EACA,wCAAA;EACA,2BAAA;AADR;AAII;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAKI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAHR;;AAOA;EACI,yBAAA;AAJJ;AAMI;EACI,yBAAA;AAJR;;AASA;EACC,YAAA;AAND;;AAQA;EACI,kCCnGY;EDoGZ,YCtGa;EDuGhB,YAAA;AALD;;AAQA;EACI,4BAAA;AALJ;;AAQI;EACI,6BAAA;AALR;;AAQI;EACI,2CAAA;AALR;;AAOI;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;AAJR;;AAMI;EACI,2CAAA;EACA,6CAAA;EACA,8CAAA;AAHR;;AAMI;EACI,WAAA;AAHR;;AAMI;EACI,aAAA;EACA,yBAAA;EACA,aAAA;AAHR;;AAOI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAJR;;AAOI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAJR;;AAOI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAJR;;AAOI;EACI,eAAA;EACA,iBAAA;EACA,WAAA;AAJR","sourcesContent":["@import '../../../scss/variables';\n.wrapper {\n\tborder: 1px solid;\n\tpadding: 30px 30px;\n\tborder-radius: 10px;\n}\n\n.fromtop {\n\tmargin-top: 3px;\n}\n\n.mat-column-select {\n\toverflow: initial;\n}\n\ntable {\n\twidth: 95%;\n}\n\ntr {\n\theight: 6rem;\n}\n\n.mat-mdc-row .mat-mdc-cell {\n\tborder-bottom: 1px solid transparent;\n\tborder-top: 1px solid transparent;\n\tcursor: pointer;\n}\n\n.mat-mdc-row:hover .mat-mdc-cell {\n\tborder-color: currentColor;\n}\n\n.demo-row-is-clicked {\n\tfont-weight: bold;\n}\n\n.row-end {\n\tmargin-top: 1.2rem;\n    margin-bottom: 1.2rem;\n    margin-right: 0.8rem;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n}\n\n.pay-inv:not([disabled])  {\n    background-color: $primary-color;\n     color: $selected-metal;\n}\n\n// Save button styles\n.save-button-container {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    padding-left: 24px;\n    gap: 8px; // Add space between buttons\n}\n\n.save-btn {\n    background-color: $primary-color;\n    color: $selected-metal;\n    width: 52px;\n    height: 52px;\n    border-radius: 20%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    transition: all 0.3s ease;\n    \n    &:not([disabled]):hover {\n        background-color: darken($primary-color, 10%);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n        transform: translateY(-2px);\n    }\n    \n    &[disabled] {\n        background-color: #e0e0e0;\n        color: #9e9e9e;\n        box-shadow: none;\n        transform: none;\n    }\n    \n    mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n        line-height: 24px;\n    }\n}\n\n.pdf-btn {\n    background-color: #d32f2f; // Red color for PDF button\n    \n    &:not([disabled]):hover {\n        background-color: darken(#d32f2f, 10%);\n    }\n}\n\n\ntable tr{\n\theight: auto;\n}\ntable th{\n    background-color: $primary-color;\n    color: $selected-metal;\n\theight: 50px;\n}\n\ntable, th:first-child{ \n    border-top-left-radius: 10px;    \n    }\n    \n    table,th:last-child{\n        border-top-right-radius: 10px;   \n    }\n    \n    table{\n        background-color: var(--primary-grey-light);\n    }\n    .mat-elevation-z2{\n        border-radius: 10px;\n        max-height: 60vh;\n        overflow-y: clip;\n    }\n    .paginator{\n        background-color: var(--primary-grey-light);\n        border-bottom-left-radius: var(--def-padding);\n        border-bottom-right-radius: var(--def-padding);\n    }\n\n    ::ng-deep .hide-arrow .mat-sort-header-arrow {\n        color: #fff;\n    }\n\n    .paginator{\n        display: flex;\n        justify-content: flex-end;\n        padding: 15px;\n    }\n\n    // Updated total summary styles - moved to right side\n    .total-summary-content {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        text-align: right;\n    }\n\n    .total-info, .invoice-count {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        text-align: right;\n        margin-bottom: 8px;\n    }\n\n    .total-label, .count-label {\n        font-size: 14px;\n        color: #666;\n        font-weight: 500;\n        margin-right: 8px;\n    }\n\n    .total-amount, .count-number {\n        font-size: 16px;\n        font-weight: bold;\n        color: #333;\n    }","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
